import {
    IMPORT_P4_EXCEPTION_DETAILS_OPEN_MODAL,
    IMPORT_P4_EXCEPTION_SEARCH_DETAILS_REQUEST,
    IMPORT_P4_EXCEPTION_SEARCH_DETAILS_RESULT,
    IMPORT_P4_EXCEPTION_GET_DETAILS_REQUEST,
    IMPORT_P4_EXCEPTION_GET_DETAILS_RESULT,
} from 'Redux/actionTypes';

export const exceptionDetailsOpenModal = (open, account) => ({
    type: IMPORT_P4_EXCEPTION_DETAILS_OPEN_MODAL,
    payload: { open, account }
})

export const exceptionSearchDetailsRequest = (data) => ({
    type: IMPORT_P4_EXCEPTION_SEARCH_DETAILS_REQUEST,
    payload: data
})

export const exceptionSearchDetailsResult = (result) => ({
    type: IMPORT_P4_EXCEPTION_SEARCH_DETAILS_RESULT,
    payload: result
})

export const exceptionGetDetailsRequest = (data) => ({
    type: IMPORT_P4_EXCEPTION_GET_DETAILS_REQUEST,
    payload: data
})

export const exceptionGetDetailsResult = (data) => ({
    type: IMPORT_P4_EXCEPTION_GET_DETAILS_RESULT,
    payload: data
})